import styled, { css } from "styled-components";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const baseStyleContainer = css`
  background: var(--white-color);
  box-shadow: var(--box-shadow4);
  border-radius: 8px;
  padding: 30px;
  display: flex;
  align-items: start;
  ${({ $studentsReport }) => $studentsReport && `width: auto;align-items: center;`}

  @media screen and (max-width: 786px) {
    padding: 1rem;
  }
  p {
    font-weight: 500;
    font-size: var(--font-size-sm);
    color: var(--blue-color-dark);
  }
  span {
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: var(--blue-color-dark);
    &:first-of-type {
      font-weight: 300;
      @media screen and (max-width: 786px) {
        align-self: end;
      }
    }
  }
`;

export const ReportRows = styled(Row)`
  ${baseStyleContainer}
`;
export const ReportDetailContainer = styled(Col)`
  display: flex;
  justify-content: start;
  align-items: start;
  ${({ $studentsReport }) => $studentsReport && `width:auto;align-items:center;`}
  @media screen and (max-width: 786px) {
    width: 100%;
  }
  a {
    font-size: var(--font-size-sm);
    @media screen and (max-width: 786px) {
      font-size: var(--font-size-xs);
    }
  }
`;
export const StudentReportRows = styled(Link)`
  ${baseStyleContainer}
  cursor: pointer;
  &::after {
    content: "";
    display: ${({ $seenReport }) => $seenReport && "none"};
    width: 10px;
    height: 10px;
    background: var(--primary-color);
    border-radius: 50%;
    position: absolute;
    left: 4%;
    @media screen and (max-width: 786px) {
      left: 6%;
    }
  }
  img {
    width: 36px;
    height: 36px;
    object-fit: cover;
    object-position: center center;
    border-radius: 50%;
  }
  .student-report-sim {
    @media screen and (max-width: 992px) {
      padding-right: 50px;
      padding-left: 20px;
    }
  }
`;
